import { trpcClient } from "@/trpc/client";
import type { LeadsConfig } from "@/types/businessData";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const PROFILE_SECTION_KEYS = [
  "company-profile",
  "icp",
  "sales-info",
  "hiring-plan",
  "leads-config",
] as const;

export type ProfileSectionKey = (typeof PROFILE_SECTION_KEYS)[number];

/**
 * Persists onboarding profile wizard data for a single section.
 * Shared by settings profile and onboarding extended steps.
 */
export async function persistProfileSection(
  businessId: string,
  key: ProfileSectionKey,
  data: unknown,
): Promise<void> {
  switch (key) {
    case "company-profile": {
      const d = data as {
        description: string;
        culture: string;
        businessModel?: string[];
        industry?: string;
      };
      await trpcClient.onboarding.saveCompanyIdentity.mutate({
        businessId,
        description: d.description,
        culture: d.culture,
        businessModel: d.businessModel,
        industry: d.industry,
      });
      break;
    }
    case "icp": {
      const d = data as {
        companyDescription: string;
        contactPersonDescription: string;
        referenceCustomers: {
          name: string;
          contactPerson?: string;
          description?: string;
        }[];
      };
      await trpcClient.onboarding.saveIcp.mutate({
        businessId,
        ...d,
      });
      break;
    }
    case "sales-info": {
      const d = data as {
        geographicArea: string;
        avgDealSize: number;
        avgDealCycleDays: number;
        avgMonthlyBudget: number;
        currency: string;
      };
      await trpcClient.onboarding.saveSalesInfo.mutate({
        businessId,
        geographicArea: d.geographicArea,
        avgDealSize: d.avgDealSize,
        avgDealCycleDays: d.avgDealCycleDays,
        avgMonthlyBudget: d.avgMonthlyBudget,
        currency: d.currency,
      });
      break;
    }
    case "hiring-plan": {
      const d = data as { hireCountNext12Months: number };
      await trpcClient.onboarding.saveHiringPlan.mutate({
        businessId,
        ...d,
      });
      break;
    }
    case "leads-config": {
      const d = data as LeadsConfig;
      await trpcClient.onboarding.saveLeadsConfig.mutate({
        businessId,
        ...d,
      });
      break;
    }
  }
}
